/* eslint-disable @typescript-eslint/no-throw-literal */
import React from 'react';
import ApiError from 'app/api/error';

// Components.
import CommunityContent from 'app/pageContents/CommunityContent';
import groupApi from 'entity/group/groupApi';
import { Group } from 'entity/group/groupRedux';

const Community = (props: { currentGroup: Group }) => {
  return <CommunityContent currentGroup={props.currentGroup} />;
};

Community.getInitialProps = async ({ query, res }) => {
  const { slug } = query;

  let currentGroup: Group = null;
  if (slug) {
    // this is route /topic/:slug to mapped group, determined by slug. else it will redirect to /community
    if (slug.length === 2 && slug[0] === 'topic') {
      const mappedGroupResponse = await groupApi.getMappedTopicToGroup(slug[1]);
      let groupLink = '/community';
      if (mappedGroupResponse.ok) {
        groupLink = `/community/${mappedGroupResponse.data.data.slug}`;
      }
      res.writeHead(301, { Location: groupLink });
      res.end();
    }

    // This to prevent multiple slash, eg: community/slugA/slugB
    if (slug.length > 1) {
      const apiError = new ApiError();
      throw apiError;
    }

    // Check if slug is a vali group
    const groupResponse = await groupApi.getGroup(slug[0]);

    // Throw as 404 error if there is no group found.
    if (!groupResponse.ok) {
      const apiError = new ApiError(groupResponse);
      throw apiError;
    }
    currentGroup = groupResponse.data.data;
  }

  return {
    currentGroup,
  };
};

export default Community;
